import React from 'react'
import PropTypes from 'prop-types'
import { isabellaL, humiL } from '../../../assets/assets'

const HumiIsabellaOnboarding = ({ strings }) => {
  return (
    <div>
      <h2>{strings.linkt_intro1}</h2>
      <div className='flexed'>
        <div>
          <img src={humiL} alt='onboarding-humi' />
          <p dangerouslySetInnerHTML={{ __html: strings.linkt_intro2 }} />
        </div>
        <div>
          <img src={isabellaL} alt='onboarding-isabella' />
          <p dangerouslySetInnerHTML={{ __html: strings.linkt_intro3 }} />
        </div>
      </div>
    </div>
  )
}

HumiIsabellaOnboarding.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string)
}

export default HumiIsabellaOnboarding
